import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {StorageService} from '../services/storage.service';
import {UrlService} from '../services/url.service';
import {Observable} from 'rxjs/Rx';
import {catchError, map} from 'rxjs/operators';
import {CurrentUser} from '../models/current-user.model';
import {UserDetailsService} from '../services/user-details.service';


@Injectable()
export class UserLoginGuard implements CanActivate {

    constructor(
      private storageService: StorageService,
      private urlService: UrlService,
      private userDetailsService: UserDetailsService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|boolean {
      if (this.storageService.userID) {
        this.urlService.navigateToDefaultDashboard();
        return false;
      } else {
        return this.userDetailsService.get_current_user(false).pipe(
          map((user: CurrentUser) => {
            this.storageService.userID = user.id;
            this.urlService.navigateToDefaultDashboard();
            return false;
          }),
          catchError(() => {
            return Observable.of(true);
          })
        );
      }
    }

}
